import { z } from 'zod'

/**
 * Semver - Semantic version string (e.g., "1.0.0", "2.1.3")
 */
export const SemverSchema = z
  .string()
  .regex(/^\d+\.\d+\.\d+$/, 'Version must be in semver format (e.g., "1.0.0")')
  .describe('Semantic version number')
export type Semver = z.infer<typeof SemverSchema>
